module.exports = __webpack_public_path__ + "static/img/generic-card@2x.8cb9b4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/generic-card@2x.png
// module id = i1am
// module chunks = 1